import { createSelector } from 'reselect';

export const getCommentsState = (state) => state.comments;

export const getCommentsForFunction = (functionId) => (state) => {
  const list = state.comments.byFunction[functionId] || [];
  return [...list].sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
};

export const getCommentCountForFunction = (functionId) => (state) =>
  state.comments.counts[functionId] || 0;

const recentSelector = (state) => state.comments.recent;

export const getRecentComments = createSelector(recentSelector, (recent) =>
  [...recent].sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
);

export const getLastReadAt = (state) => state.comments.lastReadAt;

export const getUnreadRecentCount = createSelector(
  getRecentComments,
  getLastReadAt,
  (recent, lastReadAt) => {
    if (!lastReadAt) return recent.length;
    const cutoff = new Date(lastReadAt).getTime();
    return recent.filter((c) => new Date(c.createdAt).getTime() > cutoff).length;
  }
);

export const getHasUnreadForFunction = (functionId) => (state) => {
  const count = state.comments.counts[functionId] || 0;
  if (count === 0) return false;
  const lastRead = state.comments.lastReadByFunction[functionId];
  if (!lastRead) return true;
  const recent = state.comments.recent.filter((c) => c.functionId === functionId);
  return recent.some((c) => c.createdAt > lastRead);
};

export const getLatestCreatedAtForFunction = (functionId) => (state) => {
  const list = state.comments.byFunction[functionId] || [];
  if (list.length === 0) return null;
  return list.reduce(
    (max, c) => (max == null || c.createdAt > max ? c.createdAt : max),
    null
  );
};
